import React, { Component } from 'react';
import { Container} from 'reactstrap';
import simpleReactValidator from 'simple-react-validator';
import SubHeader from './periodical_subheader';
import PeriodicalTable from './periodical_table';
import PeriodicalModel from 'shared/components/Models/periodical_model';
import DeleteConfirmationModel from 'shared/components/Models/delete_confirmation_model';
import { connect } from 'react-redux';
import {fetchPeriodicalsList,removePeridicalData,CreatePeridical,getPeridical,updatePeridicalData,checkExistPeriodical} from 'shared/actions/periodicals_action';
import {fetchFrequencyList} from 'shared/actions/frequency_action';
import AlertSuccess from 'shared/components/Alerts/alert_success';
import {fetchStatusList,fetchChargesList,fetchPreferanceList,fetchReportingList} from 'shared/actions/actions';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

class Periodicals extends Component {
  constructor(props) {
    super(props)
    this.validator = new simpleReactValidator();
    this.state={
      modal: false,
      charged_show:false,
      delete_model:false,
      delete_id:0,
      periodical_data:[],
      reporting_array:[],
      frequency:[],
      blocking:false,
      reporting_field:[{field_id:0,data_type_id:1,label:"",is_mandatory:1}],
      visible: true,
      check_exist:false,
      check_exist_message:false,
      current_name:"",
      image_name:""
    }
    this.toggle = this.toggle.bind(this);
    this.onCheck = this.onCheck.bind(this);
    this.delete_toggle = this.delete_toggle.bind(this);
    this.onSubmit=this.onSubmit.bind(this);
    this.confirm_delete_click=this.confirm_delete_click.bind(this);
    this.txtOnchange=this.txtOnchange.bind(this);
    this.onMandatoryCheck=this.onMandatoryCheck.bind(this);
    this.onrChange=this.onrChange.bind(this);
    this.saveClick=this.saveClick.bind(this);
    this.delete_report_click=this.delete_report_click.bind(this);
    this.onImageChange=this.onImageChange.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.rCancel=this.rCancel.bind(this);
    this.checkExist=this.checkExist.bind(this);
  }

  componentDidMount() {
    const {dispatch} = this.props
    dispatch(fetchPeriodicalsList())
    dispatch(fetchFrequencyList())
    dispatch(fetchStatusList())
    dispatch(fetchChargesList())
    dispatch(fetchPreferanceList())
    dispatch(fetchReportingList())
    this.setState({
      blocking:!this.state.blocking
    })
    
  }

  componentDidUpdate(prevProps, prevState) {
    
    if(this.props.periodical_delete_data!=prevProps.periodical_delete_data)
    {
      this.props.dispatch(fetchPeriodicalsList())
      this.setState({
        visible:true,
        blocking:false
      })
    }

    if(this.props.frequency_data!=prevProps.frequency_data)
    {
      this.setState({
        frequency:this.props.frequency_data
      })
    }
    if(prevProps.periodicals_data!=this.props.periodicals_data){
      this.setState({
        blocking:false
      })
    }

    if(prevProps.check_periodical!=this.props.check_periodical){

      if(this.props.check_periodical.success==true){
        this.setState({
          check_exist:true,
          check_exist_message:true
        })
      }
      else
      {
        this.setState({
          check_exist:false,
          check_exist_message:false
        })
      }
    }

    

    if(this.props.periodical_data!=prevProps.periodical_data)
    {
      console.log(this.props.periodical_data);
      if(this.props.periodical_data!=null && this.props.periodical_data!="")
      {
        var charge=0;
        var name=this.props.periodical_data.periodical[0].name;
        this.setState({
          current_name:name
        })
        
        if(this.props.periodical_data.periodical[0].is_default_seperately_charge!=undefined)
        {
           charge=this.props.periodical_data.periodical[0].is_default_seperately_charge;
        }

        var pdata=this.props.periodical_data.periodical;

        var amount=pdata[0].default_charge_amount;
        if(amount!="" && amount!=null)
        {
          amount=amount.toString();
        }

        var newparray=[{id:pdata[0].id,name:pdata[0].name,description:pdata[0].description,is_default_seperately_charge:pdata[0].is_default_seperately_charge,default_charge_type_id:pdata[0].default_charge_type_id,default_charge_amount:amount,allocation_preference_id:pdata[0].allocation_preference_id,default_frequency_type_id:pdata[0].default_frequency_type_id,default_frequency_count:pdata[0].default_frequency_count,status:pdata[0].status,contract_count:pdata[0].contract_count}];
        
        this.setState({ periodical_data: newparray,charged_show: charge,blocking:false });
        
        if(this.props.periodical_data.reporting_fields!==undefined)
        {
          this.setState({reporting_array:this.props.periodical_data.reporting_fields,blocking:false });
        }
      }
  }
}

onDismiss() {
  this.setState({ visible: false });
}

checkExist=(e)=>{
  var value=e.target.value;
  if(value!=""){
    if(this.state.current_name!=value)
    {
      this.props.dispatch(checkExistPeriodical(value));
    }
    
  }
  //console.log(value);
}

rCancel(){
 // console.log("reset click")
this.setState({
  reporting_field:[{field_id:0,data_type_id:1,label:"",is_mandatory:1}]
})
}

toggle() {
  var default_periodical=[{id:'0',name:'',description:'',is_default_seperately_charge:0,default_charge_type_id:'',default_charge_amount:'',allocation_preference_id:'',default_frequency_type_id:'',default_frequency_count:'',status:1}];
this.validator.hideMessages();
  this.setState({
    periodical_data:default_periodical,
    reporting_array:[],
    modal: !this.state.modal
  });
}

delete_toggle=(e)=> {
  this.setState({
    delete_id:e,
    delete_model: !this.state.delete_model
  });
}

confirm_delete_click=(e)=>{
  if(this.state.delete_id>0)
  {
    this.props.dispatch(removePeridicalData(this.state.delete_id))
    this.setState({
      delete_id:0,
      delete_model: !this.state.delete_model,
      blocking:!this.state.blocking
    }); 
  }  
}

edit_click=(e)=>{
  this.validator.hideMessages();
 this.props.dispatch(getPeridical(e));
 this.setState({
  modal: !this.state.modal
});

}

saveClick=(e)=>{
  var that=this;
  var report=this.state.reporting_field;

  var field_id=report[0].field_id;
  var label=report[0].label;
  var data_type_id=report[0].data_type_id;
  var is_mandatory=report[0].is_mandatory;

  if(label!="" && data_type_id>0)
  {
    var rarray=this.state.reporting_array;
    if(rarray.length>0)
    {
      field_id=rarray.slice(-1)[0].field_id;
    }
    
    rarray.push({field_id:field_id+1,label:label,data_type_id:data_type_id,is_mandatory:is_mandatory});
    var fresh_field=[{field_id:0,data_type_id:1,label:"",is_mandatory:1}]
    this.setState({
      reporting_array:rarray,
      reporting_field:fresh_field
    })
    console.log(this.state.reporting_field)
  }

}

onMandatoryCheck=(e)=>{
  var that=this;
  var id=e.target.id;
  id=id.split("-");
  var periodical = that.state.reporting_field.filter(function(item) { 
    if(item.field_id == id[1])
    {
      var val=item[id[0]];
      //console.log(val)
      if(val==1)
      {
        item[id[0]]=0;
      }
      else
      {
        item[id[0]]=1;
      }
      
    }
     return item
  });
  that.setState({reporting_field:periodical});
  var that=this;
}

onrChange=(e)=>{
  var that=this;
  var id=e.target.id;
  var value=e.target.value;
  id=id.split("-");
  var periodical = that.state.reporting_field.filter(function(item) { 
    if(item.field_id == id[1])
    {
        item[id[0]]=value;
    }
     return item
  });
  that.setState({reporting_field:periodical});
}

onrdropChange=(e)=>{
  var that=this;
  var id=e.target.id;
  var text=e.target[e.target.selectedIndex].text;
  var value=e.target.value;
  id=id.split("-");
  var periodical = that.state.reporting_field.filter(function(item) { 
    if(item.field_id == id[1])
    {
        item[id[0]]=value;
    }
     return item
  });
  that.setState({reporting_field:periodical});

}

delete_report_click=(e)=>{
  var users = this.state.reporting_array.filter(function(user) { return user.field_id != e });
		this.setState({ reporting_array: users });
}

txtOnchange=(e)=>{

  var that=this;
  var id=e.target.id;
  id=id.split("-");
  var value=e.target.value;
  //console.log(id);
  var occur_frequency=0;

  if(value=="undefined")
  {
    value="";
  }
  else{
    if(id[0]=='default_frequency_type_id'){
      var freq = this.props.frequency_data.filter(function(y) { 
        return y.id ==value
      });
      occur_frequency=freq[0].occur_frequency;
    }
  }

  var periodical = that.state.periodical_data.filter(function(item) { 
    if(item.id == id[1])
    {
      item[id[0]]=value;
      //console.log(occur_frequency);
      if(occur_frequency>0){
        item.default_frequency_count=occur_frequency;
      }
    }
     return item
  });
  //console.log(periodical);
  that.setState({periodical_data:periodical});
}

onImageChange=(e)=>{
  var that=this;
  let reader = new FileReader();
  let file = e.target.files[0];
  
    var img_id= e.target.id;
    var id=img_id.split("-");
    //console.log(file.name);
    if(file.type==="image/png" || file.type==="image/jpeg" || file.type==="image/jpg" || file.type==="image/PNG")
    {
    reader.onload = function(readerEvt) {
      var binaryString = readerEvt.target.result;
      var bianary=btoa(binaryString);
      var periodical = that.state.periodical_data.filter(function(item) { 
        //console.log(bianary);
        if(item.id == id[1])
        {
          item.icon_hash=bianary;
        }
        return item
      });
      //console.log(periodical);
      that.setState({ periodical_data: periodical,image_name:null });
    };
    reader.readAsBinaryString(file);
  }
}

onCheck=(e)=> {
   var id=e.target.id;
   id=id.split("-");
   var value=0;
        var that=this;
        if(this.state.charged_show==0)
        {
          value=1;
          that.setState({
            charged_show: 1
          });
        }
        else
        {
          value=0;
          that.setState({
            charged_show: 0
          });
        }

        var periodical = that.state.periodical_data.filter(function(item) { 
          if(item.id == id[1])
          {
            item[id[0]]=value;
            if(value==0)
            {
              item.default_charge_amount='';
              item.default_charge_type_id='';
            }
          }
           return item
        });
        console.log(periodical)
        that.setState({periodical_data:periodical});
    }

    onSubmit(){
      var that=this;
        if( that.validator.fieldValid("name") && that.validator.fieldValid("description") && that.validator.fieldValid("default_frequency_type_id") && that.validator.fieldValid("allocation_preference_id" ) && that.validator.fieldValid("status") )
        {
var name=this.state.periodical_data[0].name;
if(this.state.check_exist==false || (this.state.current_name==name)){

          var peridical_array=this.state.periodical_data;

          var id=peridical_array[0].id;
          var report_array=[];
          var report_data=this.state.reporting_array;
          if(report_data.length>0)
          {
            report_data.map(x=>{
              report_array.push({data_type_id:x.data_type_id,label:x.label,is_mandatory:x.is_mandatory});
            })
          }


          if(peridical_array[0].is_default_seperately_charge==1){
            if(that.validator.fieldValid("default_charge_type_id") && that.validator.fieldValid("default_charge_amount"))
            {
              if(id>0)
          {
            var icon_hash="";
            if(peridical_array[0].icon_hash!=undefined)
            {
              icon_hash=peridical_array[0].icon_hash;
            }
            var post_data={
              name:peridical_array[0].name,
              description:peridical_array[0].description,
              default_frequency_type_id:peridical_array[0].default_frequency_type_id,
              default_frequency_count:peridical_array[0].default_frequency_count,
              status:peridical_array[0].status,
              is_default_seperately_charge:peridical_array[0].is_default_seperately_charge,
              default_charge_type_id:peridical_array[0].default_charge_type_id,
              default_charge_amount:peridical_array[0].default_charge_amount,
              allocation_preference_id:peridical_array[0].allocation_preference_id,
              icon_hash:icon_hash,
              id:id,
              reporting_fields:report_array
            }
            console.log(post_data);
            this.props.dispatch(updatePeridicalData(post_data));
            this.setState({
              modal: !this.state.modal,
              blocking:!this.state.blocking
            });
          }
          else
          {
              var icon_hash="";
              if(peridical_array[0].icon_hash!=undefined)
              {
                icon_hash=peridical_array[0].icon_hash;
              }
              var post_data={
                name:peridical_array[0].name,
                description:peridical_array[0].description,
                default_frequency_type_id:peridical_array[0].default_frequency_type_id,
                default_frequency_count:peridical_array[0].default_frequency_count,
                status:peridical_array[0].status,
                is_default_seperately_charge:peridical_array[0].is_default_seperately_charge,
                default_charge_type_id:peridical_array[0].default_charge_type_id,
                default_charge_amount:peridical_array[0].default_charge_amount,
                allocation_preference_id:peridical_array[0].allocation_preference_id,
                icon_hash:icon_hash,
                reporting_fields:report_array
              }
              console.log(post_data);
              this.props.dispatch(CreatePeridical(post_data));
              this.setState({
                modal: !this.state.modal,
                blocking:!this.state.blocking
              });
            }

            }
            else
            {
              that.validator.showMessages();
              that.forceUpdate();
            }
          }
          else
          {
            if(id>0)
          {
            var icon_hash="";
            if(peridical_array[0].icon_hash!=undefined)
            {
              icon_hash=peridical_array[0].icon_hash;
            }
            var post_data={
              name:peridical_array[0].name,
              description:peridical_array[0].description,
              default_frequency_type_id:peridical_array[0].default_frequency_type_id,
              default_frequency_count:peridical_array[0].default_frequency_count,
              status:peridical_array[0].status,
              is_default_seperately_charge:peridical_array[0].is_default_seperately_charge,
              default_charge_type_id:peridical_array[0].default_charge_type_id,
              default_charge_amount:peridical_array[0].default_charge_amount,
              allocation_preference_id:peridical_array[0].allocation_preference_id,
              icon_hash:icon_hash,
              id:id,
              reporting_fields:report_array
            }
            console.log(post_data);
            this.props.dispatch(updatePeridicalData(post_data));
            this.setState({
              modal: !this.state.modal,
              blocking:!this.state.blocking
            });
          }
          else
          {
            var icon_hash="";
            if(peridical_array[0].icon_hash!=undefined)
            {
              icon_hash=peridical_array[0].icon_hash;
            }
            var post_data={
              name:peridical_array[0].name,
              description:peridical_array[0].description,
              default_frequency_type_id:peridical_array[0].default_frequency_type_id,
              default_frequency_count:peridical_array[0].default_frequency_count,
              status:peridical_array[0].status,
              is_default_seperately_charge:peridical_array[0].is_default_seperately_charge,
              default_charge_type_id:peridical_array[0].default_charge_type_id,
              default_charge_amount:peridical_array[0].default_charge_amount,
              allocation_preference_id:peridical_array[0].allocation_preference_id,
              icon_hash:icon_hash,
              reporting_fields:report_array
            }
            console.log(post_data);
            this.props.dispatch(CreatePeridical(post_data));
            this.setState({
              modal: !this.state.modal,
              blocking:!this.state.blocking
            });
          }
        }
        

          }
        }
       
        else
        {
          that.validator.showMessages();
          that.forceUpdate();
        }
      
    }



  render() {
    var reporting_data=[]
    const { periodicals_data,periodical_delete_data,frequency_data,status_list,charge_data,preferance_data,reporting_type_data} = this.props
    return (
      // <div className="pm-page-bg">
        <BlockUi tag="div" blocking={this.state.blocking}>
          <Container fluid={true}>
            <div className="pm-page-card">
              <div className="pm-page-card__header">
                <SubHeader toggle={this.toggle}/>
              </div>
              <div className="pm-page-card__body">
                {periodical_delete_data!=null && periodical_delete_data!=""?periodical_delete_data.success==true?<AlertSuccess visible={this.state.visible} onDismiss={this.onDismiss} color={"success"} alertText={periodical_delete_data.message}/>:<AlertSuccess visible={this.state.visible} onDismiss={this.onDismiss} color={"danger"} alertText={periodical_delete_data.message}/>:''}
                <PeriodicalTable delete_toggle={this.delete_toggle} toggle={this.toggle} data={periodicals_data} edit_click={this.edit_click}/>
              </div>
            </div>
          </Container>
          <PeriodicalModel image_name={this.state.image_name} check_exist_message={this.state.check_exist_message} onBlur={this.checkExist} rCancel={this.rCancel} onImageChange={this.onImageChange} delete_report_click={this.delete_report_click} saveClick={this.saveClick} onMandatoryCheck={this.onMandatoryCheck} onrChange={this.onrChange} reporting_field={this.state.reporting_field} reporting_array={this.state.reporting_array} validator={this.validator} isOpen={this.state.modal} toggle={this.toggle} periodical_data={this.state.periodical_data} frequency_data={frequency_data} preferance_data={preferance_data} charge_data={charge_data} status_data={status_list} reporting_type={reporting_type_data} onSubmitClick={this.onSubmit} oncheck={this.onCheck} charged_show={this.state.charged_show} onChange={this.txtOnchange} />
          <DeleteConfirmationModel isDeleteOpen={this.state.delete_model} delete_toggle={this.delete_toggle} delete_yes_toggle={this.confirm_delete_click} />
        </BlockUi>
      // </div>
    )
  }
}

function mapStateToProps(state) {
  const {postsBySubreddit } = state
  const {
    periodicals_data:periodicals_data,
    periodical_delete_data:periodical_delete_data,
    frequency_data:frequency_data,
    status_list:status_list,
    charge_data:charge_data,
    preferance_data:preferance_data,
    reporting_type_data:reporting_type_data,
    periodical_data:periodical_data,
    check_periodical:check_periodical
  } =  postsBySubreddit
  return {
    periodicals_data,
    periodical_delete_data,
    frequency_data,
    status_list,
    charge_data,
    preferance_data,
    reporting_type_data,
    periodical_data,
    check_periodical
  }
}

const AppContainer = connect( 
  mapStateToProps 
)(Periodicals);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/shared/containers/Periodicals/index.js